export default __webpack_public_path__ + "static/media/timezone_vanillaJS.2ffee66f.PNG";